export enum PaymentMethodCertificationRequest {
    IN_ADVANCE = 'IN_ADVANCE',
    AFTER_CERTIFICATION = 'AFTER_CERTIFICATION'
}
